import React from 'react';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';
import avatar from 'src/assets/avatar.jpeg';

// import github from 'src/assets/github.svg';
import github from '!!svg-inline-loader?classPrefix!src/assets/github.svg';
import fileAltSolid from '!!svg-inline-loader?classPrefix!src/assets/file-alt-solid.svg';
import Layout from '../common/components/Layout';

const HomeLogo = styled.img`
  max-width: 128px;
  display: block;
  margin: 0 auto;
  border-radius: 50%;
  transition: transform 0.15s;

  &:hover {
    transform: scale(1.1);
  }
`;

const Home: React.FC = () => {
  return (
    <Layout>
      <Helmet>
        <title>Means88 | Home</title>
      </Helmet>
      <HomeLogo
        width={128}
        height={128}
        className="dark:opacity-75"
        src={avatar}
        alt="@Means88"
      />
      <h1 className="text-4xl text-center mt-6">Means88</h1>
      <p className="description text-font-light text-center mt-8">
        A Frontend Developer <br />
        Want to Become a Stack Overflow Developer <br />
        Hanayo Lover
      </p>
      <div className="mb-3 mt-8 md:mt-12 lg:mt-16 text-center">
        <a
          href="https://github.com/Means88"
          className="w-32 btn-primary uppercase"
        >
          <span
            className="fill-current inline-block align-middle"
            dangerouslySetInnerHTML={{
              __html: github,
            }}
            style={{ width: '1em', height: '1em' }}
          />
          &nbsp;&nbsp;
          <span className="align-middle">GitHub</span>
        </a>
        <button
          // href=""
          className="w-32 ml-3 md:ml-5 btn-secondary uppercase disabled"
        >
          <span
            className="fill-current inline-block align-middle"
            dangerouslySetInnerHTML={{
              __html: fileAltSolid,
            }}
            style={{ width: '.75em', height: '1em' }}
          />
          &nbsp;&nbsp;&nbsp;
          <span className="align-middle">Blog</span>
          &nbsp;&nbsp;
        </button>
      </div>
    </Layout>
  );
};

export default Home;
